import React, {Component} from "react";
import {Link} from "react-router-dom";

import MaterialIcon from "../../../../../MaterialIcon";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';

import tippy from 'tippy.js';
import {Edit, FlipToFront, Pages, Save, Slideshow} from "@mui/icons-material";
import {PopupWrapper} from "./components/PopupWrapper";
import {LogicButton} from "./components/LogicButton";
import {LogicInteractionButton} from "./components/LogicInteractionButton";

class LogicEditorHeader extends Component {

    validateLogicName(e) {
        if (!/[0-9a-zA-Z_]/.test(e.key)) {
            e.preventDefault();
            const tip = tippy('#renameInput', {
                duration: [0, 5000],
                hideOnClick: true,
                placement: 'bottom',
                trigger: 'manual',
                content: "Only Latin letters, numbers and underscores are allowed",
                theme: 'warning'
            });
            tip[0].show();
        }
    }

    render() {
        return (
            <div className="logic-editor-header">
                <Link to="/logics" title="Logics">
                    <div className="close-box">
                        <MaterialIcon icon="close"/>
                    </div>
                </Link>
                <div className="logic-title">
                    <div className="logic-title-container">
                        <h1 className="title">All Nodes</h1>
                    </div>
                </div>
                <div className="toolbar">
                    <div className="interaction-button"><PopupWrapper popupText="Arrange" className={"list node-command"}>
                        <LogicInteractionButton label="Arrange"
                                                icon={<ViewQuiltIcon/>}
                                                disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                                onClick={() => this.props.updateGraph("arrangeLogic")}
                        />
                    </PopupWrapper>
                        <PopupWrapper popupText="Copy" className={"list node-command"}>
                            <LogicInteractionButton label="Copy"
                                                    icon={<ContentCopyIcon/>}
                                                    disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                                    onClick={() => this.props.updateGraph("copySelected")}
                            />
                        </PopupWrapper>
                        <PopupWrapper popupText="Paste" className={"list node-command"}>
                            <LogicInteractionButton label="Paste"
                                                    icon={<ContentPasteIcon/>}
                                                    onClick={() => this.props.updateGraph("pasteSelected")}
                                                    disabled={(this.props.buttonsDisabled || this.props.isReadOnly) && !this.props.nodesCopied?.copiedNodes?.length}
                            />
                        </PopupWrapper>
                        <PopupWrapper popupText="Remove" className={"list node-command"}>
                            <LogicInteractionButton label="Remove"
                                                    icon={<RemoveCircleOutlineIcon/>}
                                                    disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                                    onClick={() => this.props.updateGraph("removeSelected")}
                            />
                        </PopupWrapper>
                        <PopupWrapper popupText="Clear edges" className={"list node-command"}>
                            <LogicInteractionButton label="Clear edges"
                                                    icon={<CleaningServicesIcon/>}
                                                    disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                                    onClick={() => this.props.updateGraph("removeUnconnectedEdges")}
                            />
                        </PopupWrapper>
                    </div>
                    <div className="rename">
                        <input
                            id="renameInput"
                            type="text"
                            value={this.props.logicName}
                            disabled={this.props.buttonsDisabled}
                            onChange={(e) => this.props.changeLogicName(e.target.value)}
                            onKeyDown={(e) => this.validateLogicName(e)}
                            readOnly={this.props.buttonsDisabled || this.props.isReadOnly}
                        />
                        <PopupWrapper popupText="Rename" className={"rename"} style={{padding: "0px"}}>
                            <LogicButton label="Rename"
                                         icon={<Edit/>}
                                         disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                         onClick={() => this.props.renameLogic()}
                                         className={"action-button save-button rename-button"}/>
                        </PopupWrapper>
                    </div>
                    <div className="request-button" style={{display: "flex"}}>
                        {this.props.buttonsDisabled && (
                            <PopupWrapper popupText="Switch" className={"request-button"}>
                                <LogicButton label="Switch"
                                             icon={<FlipToFront/>}
                                             disabled={this.props.isReadOnly}
                                             onClick={() => this.props.updateGraph("cloneLogic")}
                                             className={"action-button clone-button"}/>
                            </PopupWrapper>
                        )}
                        <PopupWrapper popupText="Save" className={"request-button"}>
                            <LogicButton label="Save"
                                         icon={<Save/>}
                                         disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                         onClick={() => this.props.updateGraph("saveLogic")}
                                         className={"action-button save-button"}/>
                        </PopupWrapper>
                        {this.props.type === "COMPONENT" ? null :
                            <PopupWrapper popupText="Test" className={"request-button"}>
                                <LogicButton label="Test"
                                             icon={<Pages/>}
                                             disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                             onClick={() => this.props.updateGraph("testLogic")}
                                             className={"action-button test-button"}/>
                            </PopupWrapper>
                        }
                        <PopupWrapper popupText="Go Live" className={"request-button"}>
                            <LogicButton label="Go Live"
                                         icon={<Slideshow/>}
                                         disabled={this.props.buttonsDisabled || this.props.isReadOnly}
                                         onClick={this.props.onGoLive}
                                         className={"action-button"}/>
                        </PopupWrapper>
                    </div>
                </div>
            </div>
        );
    }
}

export default LogicEditorHeader;
